import type { PropsWithChildren } from 'react';
import type { TooltipPropsInterface } from '@zillow/constellation-10';
import { Tooltip } from '@zillow/constellation-10';

export type TooltipWrapperProps = {
  tooltipPlacement?: TooltipPropsInterface['placement'];
  tooltipText?: string;
  wrapInTooltip?: boolean;
  delayMs?: number;
};

const IMPERSONATION_TEXT = 'Disabled while impersonating';

const TooltipWrapper = ({
  children,
  tooltipPlacement,
  tooltipText = IMPERSONATION_TEXT,
  wrapInTooltip = false,
  delayMs,
}: PropsWithChildren<TooltipWrapperProps>): JSX.Element => {
  return (
    <>
      {wrapInTooltip ? (
        <Tooltip
          content={tooltipText}
          placement={tooltipPlacement || 'bottom'}
          shouldAwaitInteractionResponse
          trigger={children}
          {...(delayMs && { useHoverProps: { delay: { open: delayMs, close: 0 } } })}
        />
      ) : (
        children
      )}
    </>
  );
};

export default TooltipWrapper;
